export default "__VITE_ASSET__p4Jor6Py__"